import { Box, Text } from "@mantine/core"
import classes from "../analytics.module.css"

type Props = {
  title: string
  description?: string
}

// Plain section heading (canvas has no coloured icon tiles).
export function SectionHeader({ title, description }: Props) {
  return (
    <Box className={classes.sectionHead}>
      <Text component="h2" m={0} className={classes.sectionTitle}>{title}</Text>
      {description ? <Text className={classes.sectionSub}>{description}</Text> : null}
    </Box>
  )
}
